import { createAsyncThunk } from "@reduxjs/toolkit";
import "react-toastify/dist/ReactToastify.css";

//Include Both Helper File with needed methods
import LocationLogApi from "api/locationLogApi";
import { formatQueryParams } from "helpers/format";

export const getLocationLogs = createAsyncThunk(
  "LocationLogs",
  async (params: any = {}) => {
    try {
      const response = await LocationLogApi.locationLogs(
        formatQueryParams(params)
      );
      return response;
    } catch (error) {
      return error;
    }
  }
);




export const getReferralLogs = createAsyncThunk(
  "Referral Logs",
  async (params: any = {}) => {
    try {
      const response = await LocationLogApi.referralLogs(
        formatQueryParams(params)
      );
      return response;
    } catch (error) {
      return error;
    }
  }
);




export const getLocationLogsNew = createAsyncThunk(
  "LocationLogsNew",
  async (params: any = {}) => {
    try {
      const response = await LocationLogApi.locationLogsNew(
        formatQueryParams(params)
      );
      return response;
    } catch (error) {
      return error;
    }
  }
);
